import { render, staticRenderFns } from "./TaskIcon.vue?vue&type=template&id=085850f6&scoped=true&"
import script from "./TaskIcon.vue?vue&type=script&lang=js&"
export * from "./TaskIcon.vue?vue&type=script&lang=js&"
import style0 from "./TaskIcon.vue?vue&type=style&index=0&id=085850f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085850f6",
  null
  
)

export default component.exports